<template>
  <b-container fluid>
    <b-row class="search-t">
      <b-col>
        <span class="font-weight-bold">共 {{total}} 筆相關商品</span>
      </b-col>
      <b-col md="3" cols="6">
        <b-form-select v-model="currentSort" class="float-right">
          <b-form-select-option :value="null">排序</b-form-select-option>
          <b-form-select-option value="new">最新上架</b-form-select-option>
          <b-form-select-option value="hot">熱賣商品</b-form-select-option>
          <b-form-select-option-group label="價格">
            <b-form-select-option value="price-height">高-低</b-form-select-option>
            <b-form-select-option value="price-low">低-高</b-form-select-option>
          </b-form-select-option-group>
        </b-form-select>
      </b-col>
    </b-row>
    <b-row id="product-card-list">
      <b-col xl="3" lg="4" md="6" cols="12" class="mt-4 p-card" v-for="item in items" :key="item.id">
        <b-card border-variant="light" img-top :title="item.title" :img-src="item.img" :img-alt="item.info" img-height="240" class="text-truncate" @click="openLink(item.link)">
          <b-card-text class="text-left mb-0">${{ item.price }}</b-card-text>
          <b-button class="pull-right more-hover" size="sm" variant="outline-dark" :to="item.link" :target="linkTarget"><font-awesome-icon icon="arrow-right" size="lg" /></b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-pagination v-if="showPagi" v-model="currentPage" :total-rows="total" :per-page="each" aria-controls="product-card-list" size="lg" class="mt-5 float-right"></b-pagination>
  </b-container>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
library.add(faArrowRight)
export default {
  props: {
    list: { type: Array, default: () => [] },
    total: Number,
    each: Number,
    page: Number,
    sort: String,
    linkTarget: { type: String, default: '_self' }
  },
  computed: {
    currentPage: {
      get () {
        return this.page || 1
      },
      set (val) {
        this.$emit('page:change', val)
      }
    },
    currentSort: {
      get () {
        return this.sort || null
      },
      set (val) {
        this.$emit('sort:change', val)
      }
    },
    items () {
      return this.list.map(item => {
        const { id, pics, name, description, price, ori_price: oriPrice } = item
        const [ pic ] = pics
        const obj = {
          id,
          title: name,
          info: description,
          price: price || oriPrice,
          link: `/prod/${id}`
        }
        if (pic) {
          obj.img = this.$api.catalogImageLink(id, pic.id)
        }
        return obj
      })
    },
    showPagi () {
      return this.total > this.each
    }
  },
  methods: {
    openLink (url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style>
  .search-t {
    border-bottom: 1px solid #e9ecef;
    padding-bottom: 30px;
  }
  .search-t span {
    height: 38px;
    line-height: 38px;
    font-size: 1.15rem;
	color: #5364b5;
  }
</style>